import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import TestEnv from '@/pages/testenv'
import Navbar from '@/components/navbar'
import About from '@/components/about'
import Feature from '@/components/feature'
import CustomComponent from '@/components/CustomComponent'
import LatestBlog from '@/components/latest_blog'
import Testimonial from '@/components/testimonial'
import ContactUs from '@/components/contact_us'
import VendorSignUp from '@/components/vendorSignUp'
import Subscribe from '@/components/subscribe'
import Map from '@/components/map'
import Tile from '@/components/tile'
import Footer from '@/components/footer'
import DetailsForm from '@/components/details_form'
import Js from '@/components/js'
import BlogDetails from '@/blog/blog_details'
import BlogDetails2 from '@/blog/blog_details2'
import BlogDetails3 from '@/blog/blog_details3'
import Signin from '@/pages/sign_in'
import ForgetPassword from '@/pages/forget_password'
import ResetPassword from '@/pages/reset_password'
import Faq from '@/pages/faq'
import Color from '@/components/color'
import CreateUser from '../pages/create_user'
import UserCreate from '../pages/userCreate'
import AboutUs from '../pages/aboutus'
import ForVendors from '../pages/forvendors'
import PrivacyPolicy from '../pages/privacypolicy'
import AfterSignUp from '../pages/after_sign_up'
import AfterForgetPassword from '../pages/after_forget_password'
import MapComp from '@/components/mapcomp'
import VinAndMiles from '../pages/vin_and_miles'
import RepairEstimate from '../pages/repair_estimate'
import SelectVendor from '../pages/select_vendor'
import PaymentCustomize from '../pages/payment_customize'
import GoogleMap from '@/components/GoogleMap'
import GoogleMapTwo from '@/components/GoogleMapTwo'
import VendorSearchup from '@/components/vendorSearchup' //Amir Added 16/5/2024, for searching list of vendors
import PageNotFound from '../pages/page_not_found'
import Partnership from '../pages/partnership'


Vue.use(Router)
Vue.component('GoogleMap', GoogleMap)
Vue.component('GoogleMapTwo', GoogleMapTwo)
Vue.component('VendorSearchup', VendorSearchup) // Amir Added 10/5/2024
Vue.component('Navbar', Navbar)
Vue.component('About', About)
Vue.component('CustomComponent', CustomComponent)
Vue.component('Feature', Feature)
Vue.component('LatestBlog', LatestBlog)
Vue.component('Testimonial', Testimonial)
Vue.component('Contact_us', ContactUs)
Vue.component('VendorSignUp', VendorSignUp)
Vue.component('Subscribe', Subscribe)
Vue.component('Map', Map)
Vue.component('Footer', Footer)
Vue.component('DetailsForm', DetailsForm)
Vue.component('BlogDetails', BlogDetails)
Vue.component('BlogDetails2', BlogDetails2)
Vue.component('BlogDetails3', BlogDetails3)
Vue.component('Signin', Signin)
Vue.component('ForgetPassword', ForgetPassword)
Vue.component('Faq', Faq)
Vue.component('js', Js)
Vue.component('Tile', Tile)
Vue.component('color', Color)
Vue.component('MapComp', MapComp)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      components: {
        default: Home,
        navbar: Navbar,
      },
    },
    {
      path: '/index.html',
      name: 'Home',
      components: {
        default: Home,
        navbar: Navbar,
      },
    },
    {
      path: '/evaluate/1',
      name: 'VinAndMiles',
      components: {
        default: VinAndMiles,
        navbar: Navbar,
      },
    },
    {
      path: '/evaluate/2',
      name: 'RepairEstimate',
      components: {
        default: RepairEstimate,
        navbar: Navbar,
      },
    },
    {
      path: '/customcomponent',
      name: 'CustomComponent',
      component: CustomComponent,
      props: true,
    },
    {
      path: '/evaluate/3',
      name: 'PaymentCustomize',
      components: {
        default: PaymentCustomize,
        navbar: Navbar,
      },
    },
    // {
    //   path: '/evaluate/4',
    //   name: 'CreateUser',
    //   components: {
    //     default: CreateUser,
    //     navbar: Navbar,
    //   },
    // },
    {
      path: '/usercreate',
      name: 'UserCreate',
      components: {
        default: UserCreate,
        navbar: Navbar,
      },
    },
    {
      path: '/404',
      name: 'PageNotFound',
      components: {
        default: PageNotFound,
        navbar: Navbar,
      },
    },
    {
      path: '/sign-in',
      name: 'Signin',
      components: {
        default: Signin,
        navbar: Navbar,
      },
    },
    {
      path: '/forget-password',
      name: 'ForgetPassword',
      components: {
        default: ForgetPassword,
        navbar: Navbar,
      },
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      components: {
        default: ResetPassword,
        navbar: Navbar,
      },
    },
    {
      path: '/faq',
      name: 'Faq',
      components: {
        default: Faq,
        navbar: Navbar,
      },
    },
    {
      path: '/after-sign-up',
      name: 'AfterSignUp',
      components: {
        default: AfterSignUp,
        navbar: Navbar,
      },
    },
    {
      path: '/about',
      name: 'AboutUs',
      components: {
        default: AboutUs,
        navbar: Navbar,
      },
    },
    {
      path: '/forvendors',
      name: 'ForVendors',
      components: {
        default: ForVendors,
        navbar: Navbar,
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      components: {
        default: PrivacyPolicy,
        navbar: Navbar,
      },
    },
    {
      path: '/after-forget-password',
      name: 'AfterForgetPassword',
      components: {
        default: AfterForgetPassword,
        navbar: Navbar,
      },
    },
    {
      path: '/blog-details',
      name: 'BlogDetails',
      components: {
        default: BlogDetails,
        navbar: Navbar,
      },
    },
    {
      path: '/blog-details2',
      name: 'BlogDetails2',
      components: {
        default: BlogDetails2,
        navbar: Navbar,
      },
    },
    {
      path: '/blog-details3',
      name: 'BlogDetails3',
      components: {
        default: BlogDetails3,
        navbar: Navbar,
      },
    },
    {
      path: '/selectvendor',
      name: 'SelectVendor',
      components: {
        default: SelectVendor,
        navbar: Navbar,
      },
    },
    {
      path: '/vendor/:id',
      redirect: to => ({
        name: 'Home',
        query: {
          vendor: to.params.id,
        },
      }),
    },
    {
      // Password-gated partnership earnings calculator (standalone, no navbar).
      // Share the link with the password baked in: /partnership?key=<password>
      path: '/partnership',
      name: 'Partnership',
      component: Partnership,
    },

    {
      path: '*',
      redirect: '/404',
    },
  ],
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js